import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ClientLookup } from '../components/ClientLookup.tsx';
import { WhosCalling } from '../components/contacts/WhosCalling.tsx';
import { useLookupPermitted } from '../api/lookup.ts';

/**
 * `/lookup` — who holds a client, as a page: the receptionist's whole screen
 * (Arthur, 14 October). A call comes in about a client; this answers the name,
 * reference, status, both case managers and anyone covering, so the call goes
 * to the right person. Nothing else: no record to open, no address, no visits.
 * The receptionist holds no client scope (113), so the API would refuse them
 * anything more whatever this page showed.
 *
 * Every lookup is recorded against the person asking, so it runs on a press.
 *
 * Below it, "Who's calling?" (contacts module, Arthur, 16 October): any contact, family included, by
 * name, phone or email, and whose contact they are, for routing a call. For the receptionist and tiers 1-2.
 */
export function Lookup() {
  const [text, setText] = useState('');
  const permitted = useLookupPermitted();
  if (permitted.data && !permitted.data.permitted) {
    // General Counsel today: no client scope and no lookup, so nothing here is theirs to use.
    return (
      <div className="mx-auto max-w-3xl px-4 py-6">
        <h1 className="title-bar">Nothing is open to your roles yet</h1>
        <p className="mt-2 text-neutral-700">
          Procura shows each person what their roles cover, and yours do not include any clients or the lookup.
          An administrator can add a role if you need one.
        </p>
      </div>
    );
  }
  return (
    <div className="min-h-dvh bg-page">
      <div className="mx-auto max-w-3xl px-4 py-6">
        <h1 className="title-bar">Who holds a client</h1>
        <p className="mt-1 text-[0.9375rem] text-neutral-600">
          Type at least three letters of the client’s name, then ask. You’ll see their reference, status, case
          managers and anyone covering, so you can put the call through.
        </p>
        <label htmlFor="lookup-name" className="sr-only">The client’s name</label>
        <input
          id="lookup-name"
          type="search"
          autoComplete="off"
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="The client’s name"
          className="mt-4 min-h-[52px] w-full rounded-lg border border-neutral-300 bg-white px-3 text-base text-neutral-900"
        />
        <div className="mt-3 overflow-hidden rounded-lg border border-neutral-200 bg-white">
          <ClientLookup text={text.trim()} onOpen={() => {}} />
        </div>
        <WhosCalling />
        <p className="mt-4">
          <Link to="/communications/unmatched" className="inline-flex min-h-[44px] items-center font-semibold text-brand-text underline">
            Log a call, and calls not yet matched to a client
          </Link>
        </p>
      </div>
    </div>
  );
}
